RCDPW.module('RCDPW.console', function () {
    var console = window.console || {};
    var methods = ['log', 'warn', 'error', 'dir', 'time', 'timeEnd'];
    var method;
    var exports = {};

    for (var i = 0; i < methods.length; i++) {
        method = methods[i];
        console[method] = console[method] || noop;
        exports[method] = call(method);
    }

    return exports;

    function call(method) {
        return function () {
            console[method].apply(console, arguments);
        };
    }

    function noop() {}
});